@if (env() === 'dev') {
<div class="fixed inset-x-0 top-0 z-[9999] h-7 flex items-center justify-center bg-amber-500 text-xs font-bold text-white">
  ENTWICKLUNGSSYSTEM
</div>
} @else if (env() === 'staging') {
<div class="fixed inset-x-0 top-0 z-[9999] h-7 flex items-center justify-center bg-red-600 text-xs font-bold text-white">
  STAGING-SYSTEM
</div>
}
